const CALENDLY_WIDGET_CSS = "https://assets.calendly.com/assets/external/widget.css"
const CALENDLY_WIDGET_JS = "https://assets.calendly.com/assets/external/widget.js"

let calendlyAssetsPromise = null
const CALENDLY_GDPR_PARAM = "hide_gdpr_banner"

function buildCalendlyWidgetConfig(url, parentElement) {
  const calendlyUrl = new URL(url, window.location.origin)
  if (!calendlyUrl.searchParams.has(CALENDLY_GDPR_PARAM)) {
    calendlyUrl.searchParams.set(CALENDLY_GDPR_PARAM, "1")
  }

  const prefill = {}
  const customAnswers = {}
  const name = calendlyUrl.searchParams.get("name")
  if (name) {
    prefill.name = name
    calendlyUrl.searchParams.delete("name")
  }

  const email = calendlyUrl.searchParams.get("email")
  if (email) {
    prefill.email = email
    calendlyUrl.searchParams.delete("email")
  }

  Array.from(calendlyUrl.searchParams.keys()).forEach(key => {
    if (!/^a\d+$/.test(key)) return

    const value = calendlyUrl.searchParams.get(key)
    calendlyUrl.searchParams.delete(key)
    if (value) {
      customAnswers[key] = value
    }
  })

  if (Object.keys(customAnswers).length) {
    prefill.customAnswers = customAnswers
  }

  const search = calendlyUrl.search.replace(/\+/g, "%20")
  const widgetConfig = {
    url: calendlyUrl.origin + calendlyUrl.pathname + search + calendlyUrl.hash,
    parentElement
  }
  if (prefill.name || prefill.email || prefill.customAnswers) {
    widgetConfig.prefill = prefill
  }
  return widgetConfig
}

function loadCalendlyAssets() {
  if (calendlyAssetsPromise) return calendlyAssetsPromise

  calendlyAssetsPromise = new Promise(resolve => {
    if (window.Calendly) return resolve(window.Calendly)

    const existingScript = document.querySelector(`script[src="${CALENDLY_WIDGET_JS}"]`)
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.Calendly))
      return
    }

    if (!document.querySelector(`link[href="${CALENDLY_WIDGET_CSS}"]`)) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = CALENDLY_WIDGET_CSS
      document.head.appendChild(link)
    }

    const script = document.createElement("script")
    script.src = CALENDLY_WIDGET_JS
    script.async = true
    script.onload = () => resolve(window.Calendly)
    document.head.appendChild(script)
  })

  return calendlyAssetsPromise
}

class CalendlyModal extends window.BaseThirdPartyModal {
  load(url) {
    const widget = this.getWidget(url)
    if (widget.dataset.loaded) return Promise.resolve()

    return loadCalendlyAssets().then(Calendly => {
      if (!Calendly || widget.dataset.loaded) return
      Calendly.initInlineWidget(buildCalendlyWidgetConfig(url, widget))
      widget.dataset.loaded = "true"
    })
  }
}

customElements.define("calendly-modal", CalendlyModal)

function initCalendlyModal() {
  if (document.querySelector(".calendly-inline-widget")) {
    loadCalendlyAssets()
  }

  const modal = document.getElementById("calendly-modal")
  if (!modal) return

  const urls = new Set(
    Array.from(document.querySelectorAll("[data-calendly-url]"), trigger => trigger.getAttribute("data-calendly-url"))
  )
  if (urls.size) {
    window.onIdle(() => urls.forEach(url => modal.load(url)))
  }

  document.addEventListener("click", event => {
    const trigger = event.target.closest("[data-calendly-url]")
    if (!trigger) return
    event.preventDefault()
    modal.open(trigger.getAttribute("data-calendly-url"), trigger)
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCalendlyModal)
} else {
  initCalendlyModal()
}

document.addEventListener("shopify:section:load", event => {
  if (event.target && event.target.querySelector(".calendly-inline-widget")) {
    loadCalendlyAssets()
  }
})
